import * as T from "@radix-ui/react-tooltip"
import { tv } from "@utils/tw"
import { ReactNode } from "react"

type TooltipProps = {
  children: ReactNode
  label: ReactNode
  side?: "top" | "right" | "bottom" | "left"
  align?: "start" | "center" | "end"
  sideOffset?: number
  forceOpen?: boolean
}

export function Tooltip(props: TooltipProps) {
  if (env.admin) return props.children
  const styles = tooltipStyles()
  return (
    <T.Root open={props.forceOpen} delayDuration={700}>
      <T.Trigger asChild>{props.children}</T.Trigger>
      <T.Portal>
        <T.Content
          className={styles.content()}
          side={props.side ?? "bottom"}
          align={props.align}
          avoidCollisions
          sideOffset={props.sideOffset ?? 4}
        >
          {props.label}
          <T.Arrow className={styles.arrow()} />
        </T.Content>
      </T.Portal>
    </T.Root>
  )
}

export const TooltipProvider = T.Provider

const tooltipStyles = tv({
  slots: {
    content: "theme-dark bg-bg text-fg py-2 px-3 rounded-sm radix-tooltip-shadow cursor-default !z-[9999]",
    arrow: "fill-black",
  },
  variants: {
    padded: {},
  },
})
